export const removeLowestHighestEntries = (amtTable) => {
    //  remove the highest dollar and lowest dollar amount from the input table
    let highAmt = 0;
    let lowAmt = 0;
    let highIndx = 999;
    let lowIndx = 999;
    for (let i=0; i<amtTable.length; i++){
        if (+amtTable[i] > +highAmt || highAmt === 0){
            highAmt = +amtTable[i];
            highIndx = i;
        }
        if (+amtTable[i] < +lowAmt || lowAmt === 0){
            lowAmt = +amtTable[i];
            lowIndx = i;
        }
    }
    // Remove higher index first to avoid index shifting
    const firstToRemove = Math.max(lowIndx, highIndx);
    const secondToRemove = Math.min(lowIndx, highIndx);

    amtTable.splice(firstToRemove, 1);
    amtTable.splice(secondToRemove, 1);
    return amtTable;

}
export default removeLowestHighestEntries;